import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=750a2f2d&scoped=true"
import script from "./Matrix.vue?vue&type=script&lang=ts"
export * from "./Matrix.vue?vue&type=script&lang=ts"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=750a2f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a2f2d",
  null
  
)

export default component.exports